import tailwindConfig from "../../tailwind.config";

const mobileScreen = tailwindConfig.theme.screens.md.replace('px', '');

export default function(){	
	const tabsBlock = document.querySelectorAll( '[data-name="tabs"]' );
	
	if ( tabsBlock.length > 0 ) {
		tabsBlock.forEach(tabBlock => {
			const tabs        = tabBlock.querySelectorAll( '[data-name="tab-title"]' );
			const tabsContent = tabBlock.querySelectorAll( '[data-name="tab-item"]' );

			// First active
			if ( tabsContent.length > 0 ) {
				tabsContent[0].classList.add("active");
				tabs[0].classList.add("active");
			}


			function tabClicked( tabClickEvent ) {		
				for ( let i = 0; i < tabs.length; i++ ) {
					tabs[i].classList.remove("active");
				}
				let clickedTab = tabClickEvent.currentTarget;
				clickedTab.classList.add("active");
				tabClickEvent.preventDefault();
				
		
				let tabItems = tabBlock.querySelectorAll( '[data-name="tab-item"]' );
				for (let i = 0; i < tabItems.length; i++) {
					tabItems[i].classList.remove("active");
				}
		
				let anchorReference = tabClickEvent.target;
				let activeItemId = anchorReference.getAttribute("href");
				let activeItem = document.getElementById( activeItemId );
				activeItem?.classList.add("active");
			}
		
			for (let i = 0; i < tabs.length; i++) {
				tabs[i].addEventListener("click", tabClicked)
			}
		
			// On mobile open all tabs
			/* if ( window.innerWidth < mobileScreen ){
				tabsContent.forEach(tabContent => {
					tabContent.classList.add("active");
				});
			} */
		});
	}


}
